export default "__VITE_ASSET__a98bf5f4__"